<template>
  <Menu @on-select="changeDataMenu" :active-name="active" class="nav-sidebar" :open-names="openNames" style="width: 220px;text-align: left;">
    <MenuGroup title="组织架构">
      <MenuItem name="home">部门/员工管理</MenuItem>
      <MenuItem name="edit_positions_info">员工职位设置</MenuItem>
      <Divider class="divider_width" />
    </MenuGroup>
    <MenuGroup title="DMS平台管理">
      <MenuItem name="manufacturer_list">厂家列表</MenuItem>
      <MenuItem name="view_project_list">已使用项目条数</MenuItem>
      <MenuItem name="dms_power_set">角色/权限管理</MenuItem>
    </MenuGroup>
  </Menu>
</template>
<script>
export default{
  data(){
    return {
      active: 'home',
      openNames: []
    }
  },
  methods: {
    changeDataMenu(name) {
      if(name=='view_project_list') {
        this.$router.push({name: name, query: {sys_type: 'Dms::Dealer'}})
      } else{
        this.$router.push({name: name})
      }
    },
    active_menu_name(data){
      this.active = this.$route.name
    },
  },
  watch:{
    '$route': 'active_menu_name'
  }
}
</script>
<style type="text/css">
  .ivu-menu-vertical .ivu-menu-item-group-title{
    padding-left: 10px !important;
  }
  .divider_width{
    width: 90% !important;
    margin: 15px 0px 10px 10px !important;
    min-width: 90% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/LeftSidebar.vue